import { useDispatch, useSelector } from "react-redux";
import DayForcast from "../Components/Dashboard/DayForcast";
import HourlyForcast from "../Components/Dashboard/HourlyForcast";
import DefaultWeather from "../Components/Dashboard/DefaultWeather";
import SunRiseSunSet from "../api/SunRiseSunSet";
import {
  setCurrentDayWithTime,
  setFormattedWeather,
  setSunRiseSunSet,
  setHourlyWeatherData,
  setPlaceName,
  setLatitude,
  setLongitude,
  setPreviousPath,
  setHistoricWeatherData,
} from "../ReduxStore/App/DashBoard/dashboardSlice";
import FormattedWeather from "../api/FormattedWeather";
import HistoricData from "../api/HistoricData";
import { useEffect, useState } from "react";
import { getFormattedDateTime } from "../AllFunctions/formattedDateAndTime";
import HourlyData from "../api/HourlyData";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import getPlaceName from "../api/PlaceName";
import { useGeolocated } from "react-geolocated";
import { useLocation } from "react-router-dom";

// console.log('useGeolocated:', useGeolocated)
function Dashboard() {
  const [loader, setLoader] = useState(true);
  const [errors, setErrors] = useState([]);
  // const { geoLocationOn } = useSelector((store) => store.dashboard);
  const location = useLocation();
  const dispatch = useDispatch();
  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: false,
      },
      userDecisionTimeout: 30000,
    });
  // console.log('coords, isGeolocationAvailable, isGeolocationEnabled:', coords, isGeolocationAvailable, isGeolocationEnabled)

  const { longitude, latitude, geoLocationOn } = useSelector(
    (store) => store.dashboard
  );

  const addError = (errorMessage) => {
    setErrors((prev) => [...prev, errorMessage])
  }


  useEffect(() => {
    // Only update coordinates from geolocation if geoLocationOn is true
    // This prevents overriding manually selected locations
    if (coords && geoLocationOn) {
      dispatch(setLatitude(coords.latitude));
      dispatch(setLongitude(coords.longitude));
      dispatch(setPreviousPath(location.pathname));
      console.log("Location permission granted and saved.");
    }
  }, [coords, geoLocationOn]);

  // useEffect(() => {
  //   // Reset geoLocationOn to false on page load
  //   dispatch(setGeoLocationOn(!geoLocationOn));
  // }, []);

  // console.log('longitude, latitude,:', longitude, latitude,)

  async function fetchingSunriseData(lat, lon) {
    try {
      const res = await SunRiseSunSet(lat, lon);
      dispatch(setSunRiseSunSet(res));
    } catch (error) {
      console.log("error:", error);
      throw new Error("Could not fetch sunrise data");
    }
  }

  async function getFormattedWeatherData(lat, lng) {
    let errorMessage = null;
    try {
      let res = await FormattedWeather(lat, lng);

      // Check if res and res['Forecast data'] exist before dispatching
      if (res && res['Forecast data']) {
        dispatch(setFormattedWeather(res['Forecast data']));
      } else {
        errorMessage = 'Invalid response format from FormattedWeather API'
        console.error(errorMessage);
        // Set empty array as fallback
        dispatch(setFormattedWeather([]));
        throw new Error(errorMessage)
      }
    } catch (error) {
      console.log("error:", error);
      // Set empty array as fallback on error
      dispatch(setFormattedWeather([]));
      throw new Error(errorMessage ? errorMessage : "Could not fetch Formatted Weather Data")
    }
  }

  async function getHistoricData(lat, lng) {
    let errorMessage = null;
    try {
      let res = await HistoricData(lat, lng);
      const historicData = res['historical_data'];

      if (historicData && Array.isArray(historicData) && historicData.length > 0) {
        dispatch(setHistoricWeatherData(historicData));
      }
    } catch (error) {
      console.log("error:", error);
      dispatch(setHistoricWeatherData([]));
      throw new Error(errorMessage ? errorMessage : "Could not fetch Historic Weather Data")
    }
  }

  async function getHourlyData(lat, lng) {
    let errorMessage = null;
    try {
      let res = await HourlyData(lat, lng);
      if (res && res['Forecast data']) {
        dispatch(setHourlyWeatherData(res['Forecast data']));
      } else {
        errorMessage = 'Invalid response format from HourlyData API'
        console.error(errorMessage);
        dispatch(setHourlyWeatherData([]));
        throw new Error("")
      }
    } catch (error) {
      console.log("error:", error);
      dispatch(setHourlyWeatherData([]));
      throw new Error(errorMessage ? errorMessage : "Could not fetch Hourly Weather Data")
    }
  }

  async function getPlaceWithLatLng(lat, lng) {
    let errorMessage = null;
    try {
      let res = await getPlaceName(lat, lng);
      if (res && res.location) {
        dispatch(setPlaceName(res.location.village, res.location.sub_dist));
      } else {
        errorMessage = 'Invalid response format from Place name lookup'
        throw new Error("")
      }
    } catch (error) {
      console.log("error:", error);
      throw new Error(errorMessage ? errorMessage : "Place name lookup failed");
    }
  }

  async function loadData() {
    if (!latitude || !longitude) return;

    setLoader(true);
    setErrors([]);

    dispatch(setCurrentDayWithTime(getFormattedDateTime()));

    const results = await Promise.allSettled([
      //fetchingSunriseData(latitude, longitude),
      getFormattedWeatherData(latitude, longitude),
      getHourlyData(latitude, longitude),
      getPlaceWithLatLng(latitude, longitude),
      getHistoricData(latitude, longitude),
    ]);

    results.forEach((result) => {
      if (result.status === "rejected") {
        addError(result.reason.message || "Unknown error occurred");
      }
    });
    setLoader(false);
  }

  useEffect(() => {
    loadData()
  }, [latitude, longitude]);

  if (loader) {
    return (
      <div className="lg:flex gap-2 relative sm:h-screen  lg:h-full w-full  ">
        <div className="flex flex-col gap-2 relative lg:w-[65%] ">
          <div className="lg:h-[50%] sm:h-screen bg-primaryBgColor dark:bg-darkModePrimaryBgColor rounded-md overflow-hidden relative ">
            <Skeleton
              height="100%"
              baseColor="transparent"
              highlightColor="rgba(255, 255, 255, 0.2)"
            />
            <span className="absolute inset-0 flex items-center justify-center text-blackPrimaryText dark:text-darkModeBlackPrimaryText font-semibold">
              {/* <LoadingText/> */}
            </span>
          </div>
          <div className="lg:h-[50%] sm:hidden lg:block bg-primaryBgColor dark:bg-darkModePrimaryBgColor rounded-md overflow-hidden relative">
            <Skeleton
              height="100%"
              baseColor="transparent"
              highlightColor="rgba(255, 255, 255, 0.2)"
            />
            <span className="absolute inset-0 flex items-center justify-center text-blackPrimaryText dark:text-darkModeBlackPrimaryText font-semibold">
              {/* LoadingText  */}
            </span>
          </div>
        </div>
        <div className="bg-primaryBgColor sm:hidden lg:block dark:bg-darkModePrimaryBgColor rounded-md overflow-hidden relative lg:w-[35%]">
          <Skeleton
            height="100%"
            baseColor="transparent"
            highlightColor="rgba(255, 255, 255, 0.2)"
          />
          <span className="absolute   overflow-y-scroll inset-0 flex items-center justify-center text-blackPrimaryText dark:text-darkModeBlackPrimaryText font-semibold">
            {/* LoadingText  */}
          </span>
        </div>
      </div>
    );
  }

  if (errors.length > 0) {
    return (
      <div className="flex items-center justify-center h-screen bg-primaryBgColor dark:bg-darkModePrimaryBgColor">
        <div className="bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-200 px-6 py-5 rounded-md shadow-md max-w-md">
          <h2 className="text-lg font-semibold mb-3"> Failed to load data </h2>
          <ul className="list-disc list-inside text-sm mb-4 space-y-1">
            {errors.map((err, idx) => (<li key={idx}>{err}</li>))}
          </ul>
          <button onClick={loadData} className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md transition" > Try Again </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="flex  h-full   lg:w-full ">
        <div className=" lg:grid lg:grid-cols-12 lg:gap-2  sm:flex sm:flex-col sm:gap-2 h-full   ">
          <div className="lg:col-start-1 lg:col-end-9  lg:flex lg:flex-col  lg:gap-2 sm:flex sm:flex-col sm:gap-2  lg:h-full sm:w-screen lg:w-full ">
            <div className=" lg:h-3/5  ">
              <DefaultWeather />
            </div>

            <div className=" lg:h-2/5  ">
              <HourlyForcast />
            </div>
          </div>

          <div className=" lg:col-start-9 lg:col-end-13  ">
            <DayForcast />
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
